import type {
	RadioGroupFieldProps,
	RadioGroupFieldTypeConstraint,
} from '@bos/form';
import { RadioGroupField } from '@bos/form';
import type { FieldPathByValue, FieldValues } from 'react-hook-form';

export type AppBaseRadioGroupFieldProps<
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
> = RadioGroupFieldProps<TFieldValues, TFieldName>;

/** Use AppRadioGroupField instead of AppBaseRadioGroupField, it should be used only within packages like mobility-ui */
export const AppBaseRadioGroupField = <
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
>(
	props: AppBaseRadioGroupFieldProps<TFieldValues, TFieldName>,
) => <RadioGroupField {...props} />;
